import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {environment} from '../environments/environment';
import {HttpErrorComponent} from './shared/components/http-error/http-error.component';
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr} from '@angular/common/http';
import {AppErrorHandler} from './core/error-handler/app-error-handler.service';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {NgOptimizedImage, registerLocaleData} from '@angular/common';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import en from '@angular/common/locales/en';
import {LoadingComponent} from './shared/components/loading/loading.component';
import {MatIcon} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatListModule} from '@angular/material/list';
import {ImageGenerationComponent} from './admin/components/admin-tools/image-generation/image-generation.component';
import {LoadingInterceptor} from './shared/interceptors/loading-interceptors';
import {HttpErrorInterceptor} from './core/components/http-interceptors/http-error.interceptor';
import {MarkdownModule} from 'ngx-markdown';
import 'prismjs';
import 'prismjs/components/prism-java.min.js';
import 'prismjs/components/prism-javascript.min.js';
import 'prismjs/components/prism-python.min.js';
import 'prismjs/components/prism-typescript.min.js';
import 'prismjs/components/prism-go.min.js';
import 'prismjs/components/prism-bash.min.js';
import 'prismjs/plugins/toolbar/prism-toolbar.min.js';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard.min.js';
import 'prismjs/plugins/line-numbers/prism-line-numbers.js';
import 'prismjs/plugins/line-highlight/prism-line-highlight.js';

registerLocaleData(en);

function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: environment.SSO_SERVER,
        realm: environment.SSO_REALM,
        clientId: environment.SSO_CLIENT,
      },
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/silent-check-sso.html',
      },
    });
}

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent, HttpErrorComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    MarkdownModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
    BrowserAnimationsModule,
    KeycloakAngularModule,
    MatProgressSpinnerModule,
    NgOptimizedImage,
    LoadingComponent,
    MatIcon,
    MatMenuModule,
    MatListModule,
    ImageGenerationComponent,
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true},
    {provide: ErrorHandler, useClass: AppErrorHandler},
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppModule {
}
